export default __webpack_public_path__ + "static/media/filled-heart.8c5ecdc5.svg";